<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import configs from '../../config';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCrown,faHandHoldingDollar,faMoneyBills } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let names;
    let errorMsg = ""
    let EcanCashback = false
    let kBlock = true

    let cashbackToken = ""
    let sumWinlose = 0
    let totalCashback = 0

    let myRanking
    let isList=  false
    let isError = false
    let showBtn = true
    let cfBtn = true
    let sendBTN = true

    let cashback_ufa
    let cashback_lsm
    let cashback_gmz

    let cashbackLoglist = []

    async function gethistory() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmyranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.status==1){
                myRanking = json.payload.data
                cashback_ufa = JSON.parse(myRanking.cashback_ufa)
                cashback_lsm = JSON.parse(myRanking.cashback_lsm)
                cashback_gmz = JSON.parse(myRanking.cashback_gmz)
                isList = true
                isError = false
            }else{
                isError = true
                isList = false
            }
		} else {
            throw new Error(json);
		}
    }
    async function cashbacklogs() {
        
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/cashbacklogs", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            cashbackLoglist = json.payload
		} else {
            throw new Error(json);
		}
    }

    async function checkWinLose() {
        showBtn = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/checkwinlose", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.canCashback){
                sumWinlose = json.payload.total
                totalCashback = json.payload.totalCashback
                cashbackToken = json.payload.token
                cfBtn = false
            }else{
                errorMsg = json.payload.canCashbackmsg
                EcanCashback = true
            }
		} else {
            throw new Error(json);
		}
        showBtn = true
    }
    async function confirmCashback() {
        sendBTN = false
        if(cashbackToken == ""){
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่พบรายการกรุณาลองใหม่',
                    text: "",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
                sendBTN = true
            return
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/confirmcashback", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({token:cashbackToken})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            Swal.fire({
                heightAuto: false,
                title: 'ทำรายการสำเร็จ!',
                text: '',
                icon: 'success',
                confirmButtonText: 'OK' 
            })
            kBlock = false
            cashbacklogs()
		} else {
            throw new Error(json);
		}
        sendBTN = true
        
    }


    $: {
        gethistory()
        cashbacklogs()
    }
    
</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n"><Fa icon={faCrown} /> คืนยอดเสีย</h4></div>
    <div class="col-12" style="min-height: 500px;">
        <div class="col-12" style="text-align: center;">
            <div class="card mt-2 bg-black ">
                {#if isList}
                <div class="card-body text-center text-white">
                    <div class="row">
                        {#if myRanking.cashback_status=='O'}
                        
                        {#if cashback_ufa.status=='O'}
                        <div class="col-4 text-center "><img decoding="async" src="./assets/platform/UFA.png" alt="UFABET" class="img-fluid"> <br /> <span class="text-warning">{cashback_ufa.cashback_all}%</span></div>
                        {/if}
                        {#if cashback_lsm.status=='O'}
                        <div class="col-4 text-center">
                            <img decoding="async" src="./assets/platform/LSM.png" alt="UFABET" class="img-fluid"><br />
                            <small class="text-warning">Sport : {cashback_lsm.cashback_sport}%</small><br />
                            <small class="text-warning">Casino : {cashback_lsm.cashback_casino}%</small><br />
                            <small class="text-warning">Slot : {cashback_lsm.cashback_slot}%</small><br />
                            <small class="text-warning">Lotto : {cashback_lsm.cashback_lotto}%</small><br />
                            <small>**ตัดยอด 11:00 ของวัน</small>
                        </div>
                        {/if}
                        {#if cashback_gmz.status=='O'}
                        <div class="col-4 text-center ">
                            <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="AMB" class="img-fluid"><br />
                            <small class="text-warning">Sport : {cashback_gmz.cashback_sport}%</small><br />
                            <small class="text-warning">Casino : {cashback_gmz.cashback_casino}%</small><br />
                            <small class="text-warning">Slot : {cashback_gmz.cashback_slot}%</small><br />
                            <small class="text-warning">Lotto : {cashback_gmz.cashback_lotto}%</small>
                        </div>
                        {/if}
                        <div class="col-12 text-start ">
                            ยอดเสียขั้นต่ำ <span class="text-danger">{myRanking.cash_min.toLocaleString("en-US")}</span> บาท <br />และคืนสูงสุดไม่เกิน <span class="text-danger">{myRanking.cash_max.toLocaleString("en-US")}</span> บาท
                        </div>
                        {/if}

                        {#if kBlock}
                        <div class="col-12 text-center d-grid gap-2 mt-3">
                            {#if !cfBtn}
                            <div class="card bg-black border border-warning-subtle p-2">คุณมียอดเสียทั้งหมด {sumWinlose.toLocaleString("en-US")} บาท<br />ได้คืนจำนวน {totalCashback.toLocaleString("en-US")} บาท</div>
                            {/if}
                            {#if EcanCashback}
                            <div class="card bg-black border border-warning p-2"><span style="color: gold;">{errorMsg}</span><small>คุณมียอดเสียทั้งหมด <b style="color: gold;">{sumWinlose.toLocaleString("en-US")}</b> บาท</small></div>
                            {/if}
                        </div>
                        {#if cfBtn}
                        <div class="col-12 text-center d-grid gap-2 mt-3"> 
                            {#if showBtn}
                            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => checkWinLose()}>เชคยอดเสีย</button>
                            {:else}
                            <button type="button" class="btn btn-dark rounded-pill btn-gd"><Fa icon={faSpinner} size="lg" class="text-white" spin style="color: gold !important;" /></button>
                            {/if}
                        </div>
                        {:else}
                        <div class="col-12 text-center d-grid gap-2 mt-3">
                            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => confirmCashback()}>ยืนยัน</button>
                        </div>
                        {/if}
                        {/if}

                    </div>
                </div>
                {/if}
            </div>
        </div>

        <div class="col-12 mt-3" style="text-align: center;">
            <div class="card bg-black mb-5 pt-3 pb-3">
                <h6 class="text-white"><Fa icon={faHandHoldingDollar} size="sm" /> รายการคืนยอดเสีย</h6>
                {#each cashbackLoglist as datalist, i}
                <div class="shadow-lg rounded p-2 text-center mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                    
                    <div class="row">
                        
                        <div class="col-4 pt-3">
                            {#if datalist.status=='S'}
                            <span class="badge bg-primary" style="line-height: 15px;"><span class="text-white">สำเร็จ</span></span>
                    
                            {:else if datalist.status=='W'}
                            <span class="text-white">รอดำเนินการ</span>
                            {:else}
                            <span class="text-danger">ไม่อนุมัติ</span>
                            {/if}
                        </div>
                        <div class="col-4">
                            <Fa icon={faMoneyBills} size="sm" /> {Number(datalist.cashback_total.toFixed(2)).toLocaleString("en-US")}<br />
                            <span class="text-white text-sm">{Number(datalist.cashback_winlose.toFixed(2)).toLocaleString("en-US")}</span>
                        </div>

                        <div class="col-4">
                            <Time timestamp="{datalist.cashback_dtm*1000}" format="DD/MM/YYYY" /><br />
                            <Time timestamp="{datalist.cashback_dtm*1000}" format="HH:mm:ss" />
                        </div>

                    </div>
                </div>
                {/each}
            </div>
        </div>

    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title"><Fa icon={faCrown} /> รางวัล</h4></div>
        <div class="col-12" style="min-height: 500px;">
            <div class="col-12" style="text-align: center;">
                <div class="card mt-3 bg-black ">
                    {#if isList}
                    <div class="card-body text-center text-white">
                        <div class="row">
                            {#if myRanking.cashback_status=='O'}
                            
                            {#if cashback_ufa.status=='O'}
                            <div class="col-4 text-center "><img decoding="async" src="./assets/platform/UFA.png" alt="UFABET" class="img-fluid"> <br /> <span class="text-warning">{cashback_ufa.cashback_all}%</span></div>
                            {/if}
                            {#if cashback_lsm.status=='O'}
                            <div class="col-4 text-center">
                                <img decoding="async" src="./assets/platform/LSM.png" alt="UFABET" class="img-fluid"><br />
                                <small class="text-warning">Sport : {cashback_lsm.cashback_sport}%</small><br />
                                <small class="text-warning">Casino : {cashback_lsm.cashback_casino}%</small><br />
                                <small class="text-warning">Slot : {cashback_lsm.cashback_slot}%</small><br />
                                <small class="text-warning">Lotto : {cashback_lsm.cashback_lotto}%</small><br />
                                <small>**ตัดยอด 11:00 ของวัน</small>
                            </div>
                            {/if}
                            {#if cashback_gmz.status=='O'}
                            <div class="col-4 text-center ">
                                <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="AMB" class="img-fluid"><br />
                                <small class="text-warning">Sport : {cashback_gmz.cashback_sport}%</small><br />
                                <small class="text-warning">Casino : {cashback_gmz.cashback_casino}%</small><br />
                                <small class="text-warning">Slot : {cashback_gmz.cashback_slot}%</small><br />
                                <small class="text-warning">Lotto : {cashback_gmz.cashback_lotto}%</small>
                            </div>
                            {/if}
                            <div class="col-12 text-start ">
                                ยอดเสียขั้นต่ำ <span class="text-danger">{myRanking.cash_min.toLocaleString("en-US")}</span> บาท <br />และคืนสูงสุดไม่เกิน <span class="text-danger">{myRanking.cash_max.toLocaleString("en-US")}</span> บาท
                            </div>
                            {/if}
    
                            {#if kBlock}
                            <div class="col-12 text-center d-grid gap-2 mt-3">
                                {#if !cfBtn}
                                <div class="card bg-black border border-warning-subtle p-2">คุณมียอดเสียทั้งหมด {sumWinlose.toLocaleString("en-US")} บาท<br />ได้คืนจำนวน {totalCashback.toLocaleString("en-US")} บาท</div>
                                {/if}
                                {#if EcanCashback}
                                <div class="card bg-black border border-danger p-2">{errorMsg}<br /><small>คุณมียอดเสียทั้งหมด {sumWinlose.toLocaleString("en-US")} บาท</small></div>
                                {/if}
                            </div>
                            {#if cfBtn}
                            <div class="col-12 text-center d-grid gap-2 mt-3"> 
                                {#if showBtn}
                                <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => checkWinLose()}>เชคยอดเสีย</button>
                                {:else}
                                <button type="button" class="btn btn-dark rounded-pill btn-gd"><Fa icon={faSpinner} size="lg" class="text-white" spin style="color: gold !important;" /></button>
                                {/if}
                                <small>**ย้อนหลังได้สูงสุด 7 วัน</small>
                            </div>
                            {:else}
                            <div class="col-12 text-center d-grid gap-2 mt-3">
                                {#if sendBTN}
                                <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => confirmCashback()}>ยืนยัน</button>
                                {/if}
                            </div>
                            {/if}
                            {/if}
    
                        </div>
                    </div>
                    {/if}
                </div>
            </div>
    
            <div class="col-12 mt-3" style="text-align: center;">
                <div class="card bg-black mb-5 pt-3 pb-3">
                    <h6 class="text-white"><Fa icon={faHandHoldingDollar} size="sm" /> รายการคืนยอดเสีย</h6>
                    {#each cashbackLoglist as datalist, i}
                    <div class="shadow-lg rounded p-2 text-center mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                        
                        <div class="row">
                            
                            <div class="col-4 pt-3">
                                {#if datalist.status=='S'}
                                <span class="badge bg-primary" style="line-height: 15px;"><span class="text-white">สำเร็จ</span></span>
                        
                                {:else if datalist.status=='W'}
                                <span class="text-white">รอดำเนินการ</span>
                                {:else}
                                <span class="text-danger">ไม่อนุมัติ</span>
                                {/if}
                            </div>
                            <div class="col-4">
                                <Fa icon={faMoneyBills} size="sm" /> {Number(datalist.cashback_total.toFixed(2)).toLocaleString("en-US")}<br />
                                <span class="text-white text-sm">{Number(datalist.cashback_winlose.toFixed(2)).toLocaleString("en-US")}</span>
                            </div>
    
                            <div class="col-4">
                                <Time timestamp="{datalist.cashback_dtm*1000}" format="DD/MM/YYYY" /><br />
                                <Time timestamp="{datalist.cashback_dtm*1000}" format="HH:mm:ss" />
                            </div>
    
                        </div>
                    </div>
                    {/each}
                </div>
            </div>
    
        </div>
        </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>